import $ from 'jquery'
import Flickity from 'flickity'

import jqueryBridget from 'jquery-bridget'

$.bridget( 'flickity', Flickity )

export default {

  enable () {
    $('.block-projects-slider').flickity({
      wrapAround: true,
      groupCells: '100%',
      autoPlay: 6000,
      prevNextButtons: false,
      selectedAttraction: 0.015,
      friction: 0.5
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/blocks/block-projects.js